'use client';

import {Button} from '../atoms/Button';
import {EviteLogoIcon} from '../svg/EviteLogoIcon';
import {charcoal} from '../sass/base/_exports.sass';

export const SimpleNav = ({prev, next}) => (
  <div className="simple-nav">
    <div className="simple-nav__inner">
      {prev.onClick && (
        <Button
          onClick={prev.onClick}
          size="large"
          variant={prev.buttonVariant}
          data-qa-id={prev.qaId}
        >
          {prev.text}
        </Button>
      )}
      <span className="simple-nav__logo">
        <EviteLogoIcon color={charcoal} />
      </span>
      {next.onClick && (
        <Button
          onClick={next.onClick}
          size="large"
          variant={next.buttonVariant}
          data-qa-id={next.qaId}
        >
          {next.text}
        </Button>
      )}
    </div>
  </div>
);
